<template>
  <b-card class="dashboard-welcome">
    <p>{{ $t('dashboard.welcome-card.title') }}</p>
    <ol v-if="isLocaleObject($t('dashboard.welcome-card.list-ol'))">
      <li v-for="(value, i) in $t('dashboard.welcome-card.list-ol')" :key="i">{{ value }}</li>
    </ol>
  </b-card>
</template>

<script>
import ms from 'ms';
import i18nMixin from '@src/mixins/i18n';
import { mapRoot } from '@src/mixins/root';

export default {
  name: 'DashboardWelcome',
  mixins: [
    i18nMixin,
  ],
  data: () => ({
    currentHour: null,
    intervalHour: null,
  }),
  created() {
    this.currentHour = (new Date()).getHours();
    this.intervalHour = setInterval(() => this.currentHour = (new Date()).getHours(), ms('1h'));
  },
  beforeDestroy() {
    clearInterval(this.intervalHour);
  },
  computed: {
    ...mapRoot([ 'company', 'user', 'isRecruiter', 'isSainsburys' ]),
  },
};
</script>

<style lang="scss">
.dashboard-welcome {
  p, li {
    font-size: 17px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/welcome.vue